import React from 'react'
import './canadiancustomer.scss'
import { Link } from 'react-router-dom'
const CanadianCustomer = () => {
    return (
        <div className='canadiancustomer_wrapper'>
            <div className='border-table'>
                <table>
                    <tr>
                        <th>
                            <div className='heading'>
                                <p><b>For Canadian policyholders and customers: Complaint handling guide</b></p>
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <td>
                            <div className='content'>
                                <div className='text'>
                                    <p>Your satisfaction with our service to you is the foundation of our relationship. If you have a complaint, we invite you to share it with us following the steps below. This guide helps ensure we address a concern to your satisfaction efficiently, professionally, and fairly.</p>
                                </div>
                                <div className='text'>
                                    <p><b>Step 1: Contact us directly</b></p>
                                    <p>Often, a simple conversation can clear up a problem. We suggest you contact us to discuss the issue. When a detailed description might help, an email may be the quickest first step to an effective resolution.
                                        Contact us at 800-473-6879, <Link to=""> canadianconcerns@sentry.com</Link>, or:</p>
                                    <p>
                                        Attn: Canadian Concerns<br />
                                        Sentry Insurance<br />
                                        1800 North Point Drive, J4/21-11<br />
                                        Stevens Point, WI 54481<br />
                                    </p>
                                </div>
                                <div className='text'>
                                    <p><b>Step 2: Contact the Sentry Insurance OmbudsPerson</b></p>
                                    <p>If you’re not satisfied with the outcome of Step 1, you may choose to contact our company OmbudsPerson at
                                        <Link to="">consumer.affairs@sentry.com</Link>, 800-742-2791, or 715-346-6225. You may also share your concern with our OmbudsPerson by fax (715-346-8943) or mail:</p>
                                    <p>
                                        Attn: Consumer Affairs<br />
                                        Sentry Insurance<br />
                                        1800 North Point Drive<br />
                                        Stevens Point, WI 54481<br />
                                    </p>
                                    <p>To help our OmbudsPerson address your complaint quickly, please include or have available:</p>
                                    <ul>
                                       <li>Your contact information, including your full name, address, email, and daytime telephone number with the best time to call
                                       </li> 
                                       <li>Your Sentry account or claim number</li>

                                       <li> A summary of the details of your complaint</li>

                                       <li>The resolution you propose</li>

                                       <li>Any supporting documentation or other relevant information</li>
                                    </ul>
                                    <p>Our OmbudsPerson will create a complaint file detailing the complaint and will provide you with an acknowledgment we received it. A company representative will be assigned to promptly handle your complaint. They’ll provide you with a written response or reach out to you for additional information. If you’re dissatisfied with our resolution at this step, you may choose to escalate your complaint to Step 3.</p>
                                </div>
                                <div className='text'>
                                    <p><b>Step 3: Contact the General Insurance OmbudService (GIO)</b></p>
                                    <p>Often, a simple conversation can clear up a problem. We suggest you contact us to discuss the issue. When a detailed description might help, an email may be the quickest first step to an effective resolution.
                                        Contact us at 800-473-6879, <Link to=""> canadianconcerns@sentry.com</Link>, or:</p>
                                    <p>
                                        Attn: Canadian Concerns<br />
                                        Sentry Insurance<br />
                                        1800 North Point Drive, J4/21-11<br />
                                        Stevens Point, WI 54481<br />
                                    </p>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    )
}

export default CanadianCustomer;
